import { defineCatalogue } from '../../i18n';

export const privacyCatalogue = defineCatalogue(
  {
    'nav.label': 'Privacidade',
    title: 'Limiares de anonimato',
    'header.threshold': 'Limiar',
    'header.value': 'Mínimo de pessoas',
    'header.enabled': 'Aplicado',
    'k_general.name': 'Grupo mínimo',
    'k_general.hint':
      'Um número só aparece nos painéis quando reúne pelo menos esta quantidade de pessoas.',
    'k_sensitive.name': 'Grupo mínimo com dado sensível',
    'k_sensitive.hint': 'O mesmo, para grupos que declaram estado civil ou filhos.',
    'aria.value': 'Mínimo de pessoas para {name}',
    'aria.enabled': 'Aplicar {name}',
    'aria.save': 'Salvar {name}',
    save: 'Salvar',
    invalid: 'Informe um número inteiro de 1 pessoa ou mais.',
  },
  {
    'nav.label': 'Privacy',
    title: 'Anonymity thresholds',
    'header.threshold': 'Threshold',
    'header.value': 'Minimum people',
    'header.enabled': 'Enforced',
    'k_general.name': 'Minimum group',
    'k_general.hint':
      'A figure shows on the dashboards only when it covers at least this many people.',
    'k_sensitive.name': 'Minimum group with sensitive data',
    'k_sensitive.hint': 'The same, for groups that declare a relationship status or children.',
    'aria.value': 'Minimum people for {name}',
    'aria.enabled': 'Enforce {name}',
    'aria.save': 'Save {name}',
    save: 'Save',
    invalid: 'Enter a whole number of 1 person or more.',
  },
);

export const t = privacyCatalogue.t;
